// components/NoSsr.jsx

import dynamic from 'next/dynamic'
import React from 'react'

interface NoSsrProps {
  children: React.ReactNode
}

const NoSsr: React.FC<NoSsrProps> = props => (
  <React.Fragment>{props.children}</React.Fragment>
)

export default dynamic(() => Promise.resolve(NoSsr), {
  ssr: false
})
